import {Case} from '../../../beans/Case';
import {Belezhka} from '../../../beans/belezhka';
import {BlockUiService} from '../../../services/blockui.service';
import {CaseService} from '../../../services/case.service';
import {NomenclatureService} from '../../../services/nomenclature.service';
import {EditCaseComponent} from '../edit-case.component';
import {Component, OnInit, Input, ViewContainerRef, Host} from '@angular/core';

@Component({
	selector: 'app-edit-case-notes',
	templateUrl: './edit-case-notes.component.html',
	styleUrls: ['./edit-case-notes.component.scss']
})
export class EditCaseNotesComponent implements OnInit {

	private _caseid;
	noteContent: string;

	oldNotes: Array<Belezhka> = new Array();

	public cols = [
		{title: 'Дата', name: 'createdDate', dataType: 'date'},
		{
			title: 'Бележка', name: 'note'
			// 	, dataType: 'text-overflow'
		},
		{title: 'Потребител', name: 'createdBy'}
	];

	loadTable() {
		this.blockUi.start(this.vcRef);
		this.oldNotes = new Array<Belezhka>();
		this.caseService.getNotes(this._caseid).subscribe(
			notes => {
				this.oldNotes = notes;
				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			});
	}


	public delete(note) {
		if (confirm('Моля потвърдете изтриване на бележка : ' + note.note)) {
			this.blockUi.start(this.vcRef);
			this.caseService.deleteNote(note.id).subscribe(
				result => {
					this.loadTable();
					this.blockUi.stop();
				},
				error => {
					this.blockUi.stop();
				});
		}
	}


	constructor(
		private caseService: CaseService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		@Host() private parentComp: EditCaseComponent, ) {}

	ngOnInit() {
		this.loadTable();
	}


	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}


	private refresh() {
		this.noteContent = '';
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
		}
	}

	public addNote() {
		const note = new Belezhka();
		note.note = this.noteContent;
		this.blockUi.start(this.vcRef);
		this.caseService.addNote(note, this._caseid).subscribe(
			result => {
				this.blockUi.stop();
				alert('Бележката Беше Добавена');
				this.refresh();
				this.loadTable();
			},
			error => {
				alert('Възникна Грешка');
				this.blockUi.stop();
			});
	}

}
